import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export const Header = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onHome = location.pathname === "/";

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F4F4F2]/85 border-b border-black/5"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-logo"
          className="flex items-center gap-3 group"
        >
          <span className="font-display text-base md:text-lg tracking-tighter">
            Mrinmoy Mondal
          </span>
          <span className="hidden md:inline font-mono-mini text-[#8A8A8A]">
            / UI&nbsp;UX Designer
          </span>
        </Link>

        <nav className="flex items-center gap-6 md:gap-10">
          {onHome ? (
            <>
              <a
                href="#work"
                data-testid="nav-work"
                className="link-underline font-mono-mini text-[#0A0A0A] hidden sm:inline"
              >
                Work
              </a>
              <a
                href="#about"
                data-testid="nav-about"
                className="link-underline font-mono-mini text-[#0A0A0A] hidden sm:inline"
              >
                About
              </a>
              <a
                href="#contact"
                data-testid="nav-contact"
                className="link-underline font-mono-mini text-[#0A0A0A]"
              >
                Contact
              </a>
            </>
          ) : (
            <Link
              to="/"
              data-testid="nav-back"
              className="link-underline font-mono-mini text-[#0A0A0A]"
            >
              ← Index
            </Link>
          )}
          <div className="hidden md:flex items-center gap-2 font-mono-mini text-[#0A0A0A]">
            <span className="w-1.5 h-1.5 bg-[#FF3B30] rounded-full blink-dot" />
            Available · Q2
          </div>
        </nav>
      </div>
    </header>
  );
};
